import React, { useEffect } from "react";

function useTitle(title) {
  useEffect(() => {
    document.title = `${title} - Brri Sensometer`;
  }, [title]);
}

export default useTitle;
